export const LAKODIA_LINK = "https://www.ayana.com/labuan-bajo/lakodia";
export const AYANA_REWARD_LINK = "https://rewards.ayana.com";
export const AYANA_LINK = "https://www.ayana.com";
export const WECHAT_LINK =
  "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA4OTYxOTE2NQ==&scene=124#wechat_redirect";
export const AYANA_JAKARTA_MY_RESERVATION_LINK =
  "https://be.synxis.com/signin?chain=10237";
